import {ObjectDTO} from "../../../object-dto";

export class FamilleFacturationDto extends ObjectDTO {

}
